<template>
  <div class="daily">
     <div class="YTitle">日常巡检</div>
     <div class="from">
      <el-form :inline="true" :model="formInline" ref="searchForm">
        <el-form-item label="巡检标题：" prop="title">
          <el-input v-model.trim="formInline.title" placeholder="请输入巡检标题"></el-input>
        </el-form-item>
        <el-form-item label="时间：" prop="time">
          <el-date-picker
            v-model.trim="formInline.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format='yyyy-MM-dd HH:mm:ss'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="违规处理" prop="violationValue">
          <el-select v-model="formInline.violationValue" placeholder="请选择">
            <el-option
              v-for="item in violation"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检指标" prop="inspectionValue">
          <el-select v-model="formInline.inspectionValue" placeholder="请选择">
            <el-option
              v-for="item in inspectionIndex"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="onSubmit" round>查询</el-button>
          <el-button type="primary" @click="onReset" round>重置</el-button>
          <el-button type="success" @click="addDaily" round v-if="jurisdiction.includes('DAILYINSPECTION_ADD')" >新增日常巡检</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
        :data="TableData"
        v-loading="loading"
        border
        :header-cell-style="{background:'#F5F7FA',color:'#606266'}"
        height='100%'
        style="width: 100%">
        <el-table-column
          v-for="(item, index) in TableHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          align='center'>
        </el-table-column>
        <el-table-column
          align='center'
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="jurisdiction.includes('DAILYINSPECTION_EDIT')" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="jurisdiction.includes('DAILYINSPECTION_DELETE')" @click="deleteRow(scope.row.id)"><span style="color: #f56c6c">删除</span></el-button>
            <el-button type="text" size="small" v-if="jurisdiction.includes('DAILYINSPECTION_GET')" @click="lookDetail(scope.row.id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <YPagination
      :pageNum='pageNum'
      :pageSize='pageSize'
      :Total='total'
      @SizeChange='SizeChange'
      @CurrentChange='CurrentChange'>
    </YPagination>
    <transition name="el-fade-in-linear">
      <Add  @hiddenAdd="hiddenAdd" v-if="addIsShow" key="add"/>
      <Edit @hiddenEdit="hiddenEdit" :data="editData" v-if="editIsShow" key="edit" />
      <Detail :data="detailId" v-if="detailShow" @hiddenDetail="detailShow = false" key="detail" />
    </transition>
  </div>
</template>
<script>
import api from '@/shared/api/apps/inspection'
import Add from './components/add'
import Detail from './components/detail'
import Edit from './components/edit'
import { violationsOption, inspectionOption } from './components/data'
import { mapState } from 'vuex'
export default {
  name: 'dailyInspection',

  components: {
    Add,
    Edit,
    Detail
  },

  data () {
    return {
      formInline: {
        title: '', // 巡检标题
        time: [],
        violationValue: '', // 违规处理value 值
        inspectionValue: '' // 巡检指标value 值
      },
      editData: {},
      loading: true,
      detailId: '',
      addIsShow: false,
      editIsShow: false,
      detailShow: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      TableData: [],
      violation: violationsOption,
      inspectionIndex: inspectionOption,
      TableHead: [
        {
          prop: 'title',
          label: '巡检标题'
        },
        {
          prop: 'shopName',
          label: '巡检商户'
        },
        {
          prop: 'inspectionItem.name',
          label: '巡检指标'
        },
        {
          prop: 'handling.name',
          label: '违规处理'
        },
        {
          prop: 'appealStatus.name',
          label: '申诉状态'
        },
        {
          prop: 'lastOperatorName',
          label: '创建人'
        },
        {
          prop: 'createTime',
          label: '创建时间'
        }
      ]
    }
  },
  computed: {
    ...mapState(['jurisdiction'])
  },
  created () {
    this.getData()
    this.getIfJurisdiction()
  },
  methods: {
    getData () {
      const params = {
        method: api.listDaily,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.formInline.time.length > 0 && (params.startCreateTime = this.formInline.time[0])
      this.formInline.time[1] && (params.endCreateTime = this.formInline.time[1])
      this.formInline.title && (params.title = this.formInline.title)
      this.formInline.violationValue && (params.handling = this.formInline.violationValue)
      this.formInline.inspectionValue && (params.inspectionItem = this.formInline.inspectionValue)

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_daytodayinspection_page_list_response.code !== '10000') return
        const tableData = res.data.backend_odc_daytodayinspection_page_list_response.result.records
        this.TableData = tableData
        this.loading = false
        this.total = parseInt(res.data.backend_odc_daytodayinspection_page_list_response.result.total)
      })
    },
    addDaily () {
      this.addIsShow = true
    },
    lookDetail (id) {
      this.detailId = id
      this.detailShow = true
    },
    hiddenAdd (e) {
      if (e) {
        this.getData()
        this.addIsShow = false
        return
      }
      this.addIsShow = false
    },
    hiddenEdit (e) {
      if (e) {
        this.getData()
        this.editIsShow = false
        return
      }
      this.editIsShow = false
    },
    deleteRow (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          method: api.deleteDaily,
          id
        }
        this.axios.post(params).then(res => {
          if (res.data.backend_odc_daytodayinspection_delete_response.code !== '10000') return
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(e => {})
    },
    onSubmit () {
      this.getData()
    },
    onReset () {
      this.$refs.searchForm.resetFields()
    },
    SizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },

    CurrentChange (val) {
      this.pageNum = val
      this.getData()
    },
    openEdit (data) {
      this.editData = data
      this.editIsShow = true
    },
    // 获取权限数组
    getIfJurisdiction () {
      if (this.jurisdiction.length !== 0) return
      const params = {
        method: api.getButton
      }
      this.axios.post(params).then(res => {
        this.$store.commit('setIfJurisdiction', res.data.backend_org_ums_permission_currentuser_listButtons_response.items)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .daily
    width 100%
    height 100%
    display flex
    flex-direction column
    position relative
    .table
      flex auto
      overflow auto
      margin-bottom 20px
    >>> .el-table__body-wrapper {
      height auto !important
    }
</style>
